import { useDispatch, useSelector } from 'react-redux'
import {GlobalDispatch, GlobalState} from "./global";

export const useGlobalDispatch = useDispatch.withTypes<GlobalDispatch>();
export const useGlobalSelector = useSelector.withTypes<GlobalState>();
